import { Context } from 'effect';
import type { Effect, Layer, Schema } from 'effect';

import type {
  CookieAccessError,
  CookieRemoveError,
  CookieSetError,
} from '../../data/error/cookies';
import type { CookiesStore } from '../cookies/CookiesStore';
import { ContextTag } from '../context';

export type ProductsComparisonService = {
  readonly getProductCodes: Effect.Effect<readonly string[]>;
  readonly addProductCode: (
    code: string
  ) => Effect.Effect<void, CookieSetError | CookieAccessError | Schema.SchemaError>;
  readonly removeProductCode: (
    code: string
  ) => Effect.Effect<void, CookieSetError | CookieAccessError | Schema.SchemaError>;
  readonly clearProductCodes: Effect.Effect<void, CookieRemoveError | CookieAccessError>;
  readonly reorderProductCodes: (
    codes: string[]
  ) => Effect.Effect<void, CookieSetError | CookieAccessError | Schema.SchemaError>;
};

export class ProductsComparison extends Context.Service<
  ProductsComparison,
  ProductsComparisonService
>()(ContextTag.ProductsComparison) {
  declare static Live: Layer.Layer<ProductsComparison, never, CookiesStore>;
}
